import { LANGUAGE_NAME_MAP } from "@/pages/Private/pages/Messages/components/GenerateBar/types";

/** One choice of the Profile language picker: the value stored is the language's English name. */
export interface RoutingLanguageOption {
	id: string;
	title: string;
}

/**
 * The languages a Profile language condition offers, stored by their English name ("German"),
 * never by their code ("de"). The API compares a condition's values, lowercased, with the names
 * `prospect.language` holds ("German, English"; `campaign-routing.util.ts` `conditionMatches`), and
 * part A's migration stored the names a campaign's `languages` held, so a code would never match.
 */
export const ROUTING_LANGUAGE_OPTIONS: RoutingLanguageOption[] = Object.values(
	LANGUAGE_NAME_MAP
).map((name) => ({ id: name, title: name }));

/**
 * A stored value as the picker's option: the listed language whatever its case ("german" opens
 * as German, selected), otherwise the value exactly as stored, so nothing is renamed unasked.
 */
export const routingLanguageOptionOf = (value: string): RoutingLanguageOption =>
	ROUTING_LANGUAGE_OPTIONS.find(
		(option) => option.id.toLowerCase() === value.trim().toLowerCase()
	) ?? { id: value, title: value };
